<template>
  <div class="app-canada-post-fallback">
    <div
      v-for="(field, index) in fields"
      :key="index"
    >
      <component
        :is="field.component"
        :key="index"
        :value="field.value"
        :label="field.label"
        :name="field.name"
        :items="field.items"
        :rules="field.rules"
        :error="field.error"
        :theme="theme"
        mode="eager"
        @input="field.handleInput($event)"
      />
    </div>
  </div>
</template>

<script>
import AppInputWithValidation from '@/components/common/inputs/AppInputWithValidation'
import AppSelectWithValidation from '@/components/common/inputs/AppSelectWithValidation'
import input from '@/mixins/input'

export default {
  // Name
  name: 'AppCanadaPostFallback',

  // Components
  components: {
    AppInputWithValidation,
    AppSelectWithValidation
  },

  // Mixins
  mixins: [input],

  // Props
  props: {
    theme: {
      type: String,
      default: 'green'
    }
  },

  // Data
  data () {
    return {
      selectedProvince: '',
      provinces: [
        'AB', 'BC', 'MB', 'NB', 'NL', 'NT', 'NS',
        'NU', 'ON', 'PE', 'QC', 'SK', 'YT'
      ]
    }
  },

  computed: {
    fallbackData () {
      return this.$store.getters.fallbackData
    },

    fallBackCityError () {
      return this.$store.state.validations.fallBackCityError
    },

    fallBackStreetAddressError () {
      return this.$store.state.validations.fallBackStreetAddressError
    },

    fallBackProvinceError () {
      return this.$store.state.validations.fallBackProvinceError
    },

    fallBackPostalCodeError () {
      return this.$store.state.validations.fallBackPostalCodeError
    },

    fields () {
      return [{
        component: 'AppInputWithValidation',
        label: 'Street Address',
        name: 'street_address',
        value: this.fallbackData.street_address,
        error: this.fallBackStreetAddressError,
        handleInput: (event) => {
          this.$_input_updateState('setStreetAddress', event)
        }
      }, {
        component: 'AppInputWithValidation',
        label: 'City',
        name: 'city',
        value: this.fallbackData.city,
        error: this.fallBackCityError,
        handleInput: (event) => {
          this.$_input_updateState('setCity', event)
        }
      }, {
        component: 'AppSelectWithValidation',
        label: 'Province or Territory',
        name: 'province',
        value: this.selectedProvince || this.fallbackData.province,
        items: this.provinces,
        error: this.fallBackProvinceError,
        handleInput: (event) => {
          this.selectProvince(event)
          this.$_input_updateState('setProvince', event)
        }
      }, {
        component: 'AppInputWithValidation',
        label: 'Postal Code',
        name: 'postal_code',
        value: this.fallbackData.postal_code,
        error: this.fallBackPostalCodeError,
        handleInput: (event) => {
          this.$_input_updateState('setPostalCode', event)
        }
      }]
    }
  },

  mounted () {
    this.$store.dispatch('clearCPostValues')
  },

  methods: {
    selectProvince (province) {
      this.selectedProvince = province
    }
  }
}
</script>

<style scoped lang="scss">
</style>
